export type Age = { unit: 'minute' | 'hour' | 'day'; count: number }

const MINUTE = 60_000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

export const elapsed = (since: Date | string, now: Date): Age => {
  const milliseconds = Math.max(now.getTime() - new Date(since).getTime(), 0)
  if (milliseconds < HOUR) return { unit: 'minute', count: Math.max(Math.floor(milliseconds / MINUTE), 1) }
  if (milliseconds < DAY) return { unit: 'hour', count: Math.floor(milliseconds / HOUR) }
  return { unit: 'day', count: Math.floor(milliseconds / DAY) }
}
